/** Match-3 board constants (shared by the board, the playback and the tests). */

/** SVG user units per cell. */
export const CELL = 100;

export const GEM_CODES = ['STR', 'AGI', 'INT', 'GOLD', 'GEM'];

/**
 * Pieces are our game items (v1.47.0): hero head, key, chest, ticket, GRAM — each on its own coloured tile
 * so the board stays readable. The server codes (STR/AGI/…) are unchanged.
 */
export const GEM_META = {
  STR: { name: 'Hero', icon: '/character/Batman_Head.png', base: '#ff3d55', light: '#ffc0c8', dark: '#9c0f28' },
  AGI: { name: 'Key', icon: '/lootbox/icon_key_green.png', base: '#2fd77a', light: '#c4ffdc', dark: '#0b7040' },
  INT: { name: 'Chest', icon: '/lootbox/icon_chest_blue.png', base: '#3a8dff', light: '#c2dcff', dark: '#163fa6' },
  GOLD: { name: 'Ticket', icon: '/ticket_icon.png', base: '#ffc928', light: '#fff4b8', dark: '#a86c00' },
  GEM: { name: 'GRAM', icon: '/gram.png', base: '#b25cff', light: '#ead0ff', dark: '#5616a6' },
  RAINBOW: { name: 'Rainbow orb', shape: 'orb', base: '#ffffff', light: '#ffffff', dark: '#999999' },
};

/** Playback timings, ms (tightened in v1.43.0 — the game felt sluggish). */
export const TIMING = {
  swap: 150,
  special: 300,
  clear: 230,
  fallPerCell: 55,
  fallBase: 120,
  fallMax: 440,
  spawn: 230,
  shuffle: 720,
  end: 900,
  timeout: 900,
  invalid: 300,
  comboBanner: 900,
  float: 900,
};

/** Idle time before the client asks the server for a hint. */
export const HINT_IDLE_MS = 5000;

/** Swipe threshold in screen px. */
export const SWIPE_PX = 20;
